/**
 * @generated SignedSource<<0e22ff5a0d081ac73748e4a0d76236ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "CustomerPortfolioNavigation_portfolio",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Portfolio",
  "abstractKey": null
};

node.hash = "ab0dbb1a4b6aeda00f67a7508c7398d9";

export default node;
